import configdata from "./config.json";
import httpService from "./httpService";

let apiEndpoint = "";

if (process.env.NODE_ENV !== "production") {
  apiEndpoint = `${configdata.apiUrl}/detectors`;
} else {
  apiEndpoint = `${configdata.apiUrl}/detectors`;
}

export function generateBlog(data) {
  return httpService.post(`${apiEndpoint}/ai_blog_generate`, data);
}

export function improveBlog(data) {
  return httpService.post(`${apiEndpoint}/ai_blog_improve`, data);
}

export function rewriteBlog(data) {
  return httpService.post(`${apiEndpoint}/ai_blog_rewrite`, data);
}

export function expandBlog(data) {
  return httpService.post(`${apiEndpoint}/ai_blog_expand`, data);
}

export function humanizeBlog(data) {
  return httpService.post(`${apiEndpoint}/ai_blog_humanize`, data);
}

export function generateSlug(data) {
  return httpService.post(`${apiEndpoint}/ai_blog_slug`, data);
}

//Blogs AI Business Tool

export function generateSlogan(data) {
  return httpService.post(`${apiEndpoint}/ai_slogan_generate`, data);
}

export function generateBrandStrategy(data) {
  return httpService.post(`${apiEndpoint}/ai_brand_strategy`, data);
}

export function generateBusinessIdea(data) {
  return httpService.post(`${apiEndpoint}/ai_business_idea_generator`, data);
}

export function generatePersona(data) {
  return httpService.post(`${apiEndpoint}/ai_persona_generator`, data);
}

export function generateBookIdea(data) {
  return httpService.post(`${apiEndpoint}/ai_book_idea_generator`, data);
}

export function generateBookOutline(data) {
  return httpService.post(`${apiEndpoint}/ai_book_outline_generator`, data);
}

export function generateBookCoverIdeas(data) {
  return httpService.post(`${apiEndpoint}/ai_book_cover_ideas`, data);
}

export function generateBookSummary(data) {
  return httpService.post(`${apiEndpoint}/ai_book_summary_generator`, data);
}

// AI Advertising Tools

export function generateLinkedInAds(data) {
  return httpService.post(`${apiEndpoint}/ai_linkedin_ads_generator`, data);
}

export function generateTwitterAds(data) {
  return httpService.post(`${apiEndpoint}/ai_twitter_ads_generator`, data);
}

export function generateInstagramAds(data) {
  return httpService.post(`${apiEndpoint}/ai_instagram_ads_generator`, data);
}

export function generateGoogleAds(data) {
  return httpService.post(`${apiEndpoint}/ai_google_ads_generator`, data);
}




export default {
  generateBlog,
  improveBlog,
  rewriteBlog,
  expandBlog,
  humanizeBlog,
  generateSlug,

  //Blogs AI tools 

  generateSlogan,
  generateBrandStrategy,
  generateBusinessIdea,
  generatePersona,
   generateBookIdea,
   generateBookOutline,
   generateBookCoverIdeas,
   generateBookSummary,
   generateLinkedInAds,
   generateTwitterAds,
   generateInstagramAds,
   generateGoogleAds,
};
